import http from '../../http';
import { SERVER_URL } from '../../config';

export const getHomePostData = () => http.get(`${SERVER_URL}/api-main/v1/home/posts`, {});